import React from 'react';
import TooltipContainer from './tooltip_container';

interface TooltipIconProps {
	infoText: string;
	onClick?: (...args: unknown[]) => void;
	className: string;
	cy?: string;
	userpilot?: string;
}

export const TooltipIcon = ({infoText, className, cy, userpilot, onClick}: TooltipIconProps) => {
	return (
		<TooltipContainer infoText={infoText}>
			<div data-cy={cy} data-userpilot={userpilot} onClick={onClick} className={className} />
		</TooltipContainer>
	);
};
